"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlCartesian2dTraceTransformBinder = exports.GlCartesian2dTraceBinder = exports.TraceBinderIdentifier = void 0;
const rc_js_util_1 = require("rc-js-util");
const core_1 = require("@visualization-tools/core");
/**
 * @public
 */
exports.TraceBinderIdentifier = Symbol("trace binder");
/**
 * @public
 * {@inheritDoc IGlTraceBinder}
 */
class GlCartesian2dTraceBinder extends core_1.AGlInstancedBinder {
    constructor(bindsOutput = false) {
        super();
        this.bindsOutput = bindsOutput;
        this.binderClassificationId = exports.TraceBinderIdentifier;
        this.linkId = linkId;
        // pixel size at 0, trace color on first row
        this.config = rc_js_util_1.Mat4.f32.factory.createOneEmpty();
        this.colorCache = rc_js_util_1.Vec4.f32.factory.createOneEmpty();
        this.bindings = {
            positionAttribute: new core_1.GlFloatAttribute("traceConnector_position", new core_1.GlFloatBuffer(null), 4),
            configUniform: new core_1.GlMat4Uniform("traceConnector_config", this.config),
        };
        this.specification = new core_1.GlProgramSpecification(core_1.GlShader.combineShaders([
            new core_1.GlShader(core_1.GlShader.getShaderFlag("TRACE_CONNECTOR_BINDS_OUTPUT", bindsOutput), bindsOutput ? 300 : undefined),
            vertex,
        ]), fragmentShader, [], [], bindsOutput ? ["traceConnector_outPosition"] : undefined);
    }
    getTransformBinder() {
        return new GlCartesian2dTraceTransformBinder(true);
    }
    getBinderId() {
        return "cartesianTrace2d";
    }
    link(binders) {
        const attributeState = this.bindings.positionAttribute.getSharableState();
        for (let i = 0, iEnd = binders.length; i < iEnd; ++i) {
            binders[i].bindings.positionAttribute.link(attributeState);
        }
    }
    setBufferLayout(bufferLayout) {
        const theirBuffer = bufferLayout.swapBuffer(this.bindings.positionAttribute.getBuffer(), 0);
        this.bindings.positionAttribute.setBuffer(theirBuffer);
    }
    getBufferLayout() {
        return new core_1.BufferLayout([new core_1.GlBuffer(null, Float32Array)]);
    }
    areAttributesDirty(entity) {
        const changeId = this.getChangeId(entity);
        return this.bindings.positionAttribute.getBuffer().changeId !== changeId;
    }
    initialize(componentRenderer) {
        this.bindings.positionAttribute.initialize(componentRenderer);
        this.bindings.configUniform.initialize(componentRenderer);
    }
    updateData(entity) {
        const changeId = this.getChangeId(entity);
        this.bindings.positionAttribute.setData(entity.graphicsSettings.traces, changeId);
        this.config.setRow(1, this.colorCache.setRGBAColor(entity.graphicsSettings.traceColor, true));
        this.config[0] = entity.graphicsSettings.traceLinePixelSize;
        this.bindings.configUniform.setData(this.config, changeId);
    }
    updatePointers() {
        // static pointers
    }
    bindUniforms(componentRenderer) {
        this.bindings.configUniform.bind(componentRenderer);
    }
    bindAttributes(componentRenderer) {
        this.bindings.positionAttribute.bindArray(componentRenderer);
    }
    bindInstanced(componentRenderer, divisor, usage) {
        this.bindings.positionAttribute.bindArrayInstanced(componentRenderer, divisor, usage);
    }
    getChangeId(entity) {
        return entity.changeId;
    }
}
exports.GlCartesian2dTraceBinder = GlCartesian2dTraceBinder;
// @formatter:off
// language=GLSL prefix="#if __VERSION__ >=300 && __VERSION__ < 400 \n #define ATTRIBUTE in \n #define VARYING out \n #else \n #define ATTRIBUTE attribute \n #define VARYING varying \n #endif"
const vertex = new core_1.GlShader(`
ATTRIBUTE highp vec4 traceConnector_position;
uniform lowp mat4 traceConnector_config;

mat2 traceConnector_getPosition()
{
    return mat2(traceConnector_position);
}

float traceConnector_getWidth()
{
    return traceConnector_config[0][0];
}

#ifdef TRACE_CONNECTOR_BINDS_OUTPUT
VARYING vec4 traceConnector_outPosition;

void traceConnector_setPosition(vec2 lower, vec2 upper)
{
    traceConnector_outPosition = vec4(lower, upper);
}
#endif

`);
// @formatter:on
// language=GLSL prefix="#if __VERSION__ >=300 && __VERSION__ < 400 \n #define VARYING in \n #define TEXTURE2D texture \n #else \n #define VARYING varying \n #define TEXTURE2D texture2D \n #endif \n void setFragmentColor(in lowp vec4 color);"
const fragmentShader = new core_1.GlShader(`
uniform lowp mat4 traceConnector_config;

lowp vec4 traceConnector_getColor()
{
    return traceConnector_config[1];
}
`);
const linkId = Symbol("cart-trace-2d");
/**
 * @internal
 */
class GlCartesian2dTraceTransformBinder extends GlCartesian2dTraceBinder {
    setResultBuffers(entity, exchangeBinder, transformRenderer, usage = transformRenderer.context.STREAM_DRAW) {
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            const buffersAreDifferent = this.bindings.positionAttribute.getBuffer() !== exchangeBinder.bindings.positionAttribute.getBuffer();
            rc_js_util_1._Debug.assert(buffersAreDifferent, "attempted to bind input to output");
        });
        const bufferByteSize = entity.data.getTraceCount() * 4 * Float32Array.BYTES_PER_ELEMENT;
        exchangeBinder.bindings.positionAttribute.setSize(transformRenderer.context, bufferByteSize, usage, entity.changeId);
        exchangeBinder.bindings.positionAttribute.bindTransform(transformRenderer, 0);
    }
    clearResultBuffers(transformRenderer) {
        transformRenderer.context.bindBufferBase(transformRenderer.context.TRANSFORM_FEEDBACK_BUFFER, 0, null);
    }
    getTransformId() {
        return "cartesianTrace2d";
    }
    resetState() {
        this.bindings.positionAttribute
            .getBuffer()
            .resetState();
    }
}
exports.GlCartesian2dTraceTransformBinder = GlCartesian2dTraceTransformBinder;
//# sourceMappingURL=gl-cartesian-2d-trace-binder.js.map